// utils/getSubdomain.js
export const getSubdomain = () => {
    const host = window.location.hostname; // ashoka-international-school.localhost
    const parts = host.split('.');
  
    if (host.includes('localhost')) {
      return parts[0]; // ashoka-international-school
    }
  
    // For production domains like green-valley.isnartecherp.online
    if (parts.length > 2) {
      return parts[0]; // green-valley
    }
  
    return null; // No subdomain
  };
  